module.exports = "<div class=\"row q-marg-bottom-lg certificate\" id=certificates> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-7 col-xs-12\"> <input type=text class=\"q-input q-stretch var-attr-val\" name=certificate id=\"certficate-row-{%- highestId %}\" placeholder=\"Enter certification name \" maxlength=75 /> </div> <div class=\"col-md-2 col-xs-12\"> <a href=# name=remove_certficate_row id=\"certficate-remove-row-{%- highestId %}\" class=\"base-btn purple-btn q-marg-top-md-at-md remove_certficate_row\"> Remove </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/standardPlatformFacilitySetupWizard/html/certificateRow.html
// module id = 1431
// module chunks = 1